import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=685142db&scoped=true&"
import script from "./Messaging.vue?vue&type=script&lang=js&"
export * from "./Messaging.vue?vue&type=script&lang=js&"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=685142db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685142db",
  null
  
)

export default component.exports